<bwc-sub-navigation [items]="subNavItems"></bwc-sub-navigation>
<router-outlet></router-outlet>
